import React from 'react';
import { Wrench } from 'lucide-react';

const UnderMaintenance = () => {
  return (
    <div
      style={{
        height: '100vh',
        maxHeight: '100vh',
        boxSizing: 'border-box',
        background: '#ffffff',
        fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        color: '#0f172a',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden'
      }}
    >
      {/* ── TOP HEADER / LOGO ─────────────────────────────────────────────── */}
      <header
        style={{
          width: '100%',
          maxWidth: '1320px',
          margin: '0 auto',
          padding: '24px 32px 12px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {/* 3x3 Dots Brand Grid */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '2.5px',
              width: '20px',
              height: '20px'
            }}
          >
            {[...Array(9)].map((_, i) => (
              <div
                key={i}
                style={{
                  width: '4.5px',
                  height: '4.5px',
                  borderRadius: '50%',
                  background: '#dc2626'
                }}
              />
            ))}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span
              style={{
                fontSize: '15px',
                fontWeight: 900,
                letterSpacing: '0.06em',
                color: '#0f172a',
                lineHeight: 1.1
              }}
            >
              INFRAEDGE
            </span>
            <span
              style={{
                fontSize: '7.5px',
                fontWeight: 800,
                letterSpacing: '0.14em',
                color: '#dc2626',
                lineHeight: 1.2
              }}
            >
              RED LIGHT THERAPY
            </span>
          </div>
        </div>
      </header>

      {/* ── MAIN CONTENT (SINGLE FRAME HERO) ──────────────────────────────── */}
      <main
        style={{
          flex: 1,
          width: '100%',
          maxWidth: '1320px',
          margin: '0 auto',
          padding: '0 32px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          minHeight: 0
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.1fr)',
            alignItems: 'center',
            gap: '40px'
          }}
        >
          {/* LEFT COLUMN: BADGE, HEADLINE & DESCRIPTION */}
          <div style={{ maxWidth: '520px' }}>
            {/* Pill Badge */}
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: '#fef2f2',
                border: '1px solid #fee2e2',
                borderRadius: '999px',
                padding: '6px 14px',
                color: '#dc2626',
                fontSize: '12.5px',
                fontWeight: 800,
                marginBottom: '20px'
              }}
            >
              <Wrench size={14} color="#dc2626" />
              <span>We'll be back soon</span>
            </div>

            {/* Main Headline */}
            <h1
              style={{
                fontSize: 'clamp(32px, 4vw, 50px)',
                fontWeight: 900,
                color: '#0f172a',
                lineHeight: 1.14,
                letterSpacing: '-0.025em',
                margin: '0 0 16px 0'
              }}
            >
              Our Website is<br />
              <span style={{ color: '#dc2626' }}>Under Maintenance</span>
            </h1>

            {/* Subtitle / Paragraph */}
            <p
              style={{
                fontSize: 'clamp(14px, 1.2vw, 16px)',
                color: '#64748b',
                lineHeight: 1.65,
                margin: 0,
                maxWidth: '480px'
              }}
            >
              We're currently working on some updates to bring you a better and faster experience. Thank you for your patience!
            </p>
          </div>

          {/* RIGHT COLUMN: 3D ILLUSTRATION */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              maxHeight: '100%'
            }}
          >
            <img
              src="/maintenance-illustration.png"
              alt="Our Website is Under Maintenance"
              style={{
                width: '100%',
                maxWidth: '560px',
                maxHeight: 'min(62vh, 500px)',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
                filter: 'drop-shadow(0 10px 24px rgba(220, 38, 38, 0.05))'
              }}
            />
          </div>
        </div>
      </main>

      {/* ── FOOTER ────────────────────────────────────────────────────────── */}
      <footer
        style={{
          width: '100%',
          borderTop: '1px solid #f1f5f9',
          background: '#ffffff',
          flexShrink: 0
        }}
      >
        <div
          style={{
            maxWidth: '1320px',
            margin: '0 auto',
            padding: '18px 32px',
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '12px'
          }}
        >
          {/* Footer Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '2px',
                width: '15px',
                height: '15px'
              }}
            >
              {[...Array(9)].map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: '3.5px',
                    height: '3.5px',
                    borderRadius: '50%',
                    background: '#dc2626'
                  }}
                />
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span
                style={{
                  fontSize: '13px',
                  fontWeight: 900,
                  letterSpacing: '0.05em',
                  color: '#0f172a',
                  lineHeight: 1.1
                }}
              >
                INFRAEDGE
              </span>
              <span
                style={{
                  fontSize: '6.5px',
                  fontWeight: 800,
                  letterSpacing: '0.12em',
                  color: '#dc2626',
                  lineHeight: 1.2
                }}
              >
                RED LIGHT THERAPY
              </span>
            </div>
          </div>

          {/* Copyright */}
          <div style={{ fontSize: '12.5px', color: '#64748b', fontWeight: 500 }}>
            © {new Date().getFullYear()} InfraEdge. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default UnderMaintenance;
